import type { FaireProductEntity } from "../../entity_types/product";

export const p_75qbtcfsxp: FaireProductEntity = {
  token: "p_75qbtcfsxp",
  type: "product",
  name: "Easily Distracted By Power Tools Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/cf8a3aa1c7debffe4567c984740cee30eb92f8f5c6442e6d6160a925528cd3ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/169f4a260d18f4a2f3baf7c83ed587245195264ed807524e91f1b42114cfa847.jpeg",
    "https://cdn.faire.com/fastly/c8c9acb42f8ab6be15ae2e7612a9a5aeb8e598b9feb8916c18b699fa2f7e6d49.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/22a69fcba47365a95c2e34b673647ee8c6b700afd38b3ee16b5ce2b2a44a2034.jpeg",
    "https://cdn.faire.com/fastly/78d5e6afb5aecbd123fdd336f490e2d517c7a3c6c638307c50d024b2f3477e93.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the one who can’t walk past a hardware aisle without getting a buzz. These socks are here to support any loud, sawdusty ambitions. 🥽\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:27.950Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
